module.exports = __webpack_public_path__ + "img/20190625161925QQ截图20190624162726.9d48ae1d.png";